import { isNumberValue, isStringValue } from '../guard';
import log from '../log';
import { makeReduceKey } from '../window/reduceKey';
var MatchStats = /** @class */ (function () {
  function MatchStats() {}
  MatchStats.prototype.dataType = function () {
    return 'string';
  };
  MatchStats.prototype.initialValue = function () {
    return { v: 0, k: 0 };
  };
  MatchStats.prototype.calculateFromValue = function (oldValue, value, option) {
    if (!isStringValue(value) || !option) return oldValue;
    try {
      if (this.match(option, value)) {
        var newValue = this.calculate(oldValue);
        return newValue;
      } else {
        var newValue = this.calculate(oldValue, 0);
        return newValue;
      }
    } catch (err) {
      log('Failed to calculate the stats (match).', err);
      return oldValue;
    }
  };
  MatchStats.prototype.calculateFromStats = function (oldValue, value) {
    var newValue = this.calculate(oldValue, value.v);
    return newValue;
  };
  MatchStats.prototype.gc = function (values) {
    return values;
  };
  MatchStats.prototype.calculate = function (oldValue, value) {
    if (value === void 0) {
      value = 1;
    }
    oldValue.v = isNumberValue(oldValue.v) ? oldValue.v : 0;
    value = isNumberValue(value) ? value : 0;
    var newValue = { v: 0, k: makeReduceKey() };
    newValue.v = oldValue.v + value;
    return newValue;
  };
  MatchStats.prototype.match = function (option, value) {
    if (!option.regex && !option.text) {
      throw new Error('Match condition is not define.');
    }
    if (option.regex) {
      return this.matchRegex(option.regex, value);
    } else {
      return option.text === value;
    }
  };
  MatchStats.prototype.matchRegex = function (regex, value) {
    var re = new RegExp(regex);
    return re.test(value);
  };
  return MatchStats;
})();
export default new MatchStats();
